// Brand tokens — shared with the landing site (sampled from the Despar Clean logo).
export const colors = {
  green: '#159c1e', // primary
  greenDark: '#0f7817',
  greenLight: '#e6f5e7',
  red: '#e2231a', // secondary
  redLight: '#fde7e6',
  yellow: '#f4e400', // accent
  amber: '#c98900', // pending state text
  amberLight: '#fdf3d9',
  ink: '#141414',
  slate: '#5a615a',
  mist: '#f4f7f4', // app background
  card: '#ffffff',
  line: '#e4e8e3',
  white: '#ffffff',
}

export const bp = {
  tablet: '900px',
  mobile: '600px',
}

// Layout tokens — consumed by the public marketing pages (Components/marketing/*).
// `section` is used directly as a `padding` shorthand.
export const layout = {
  maxWidth: '1200px',
  section: '5rem 1.5rem',
  radius: '16px',
}

// Canonical status states → colours. Every table/pill maps its raw status to one
// of these in the API layer, so components never branch on backend strings.
export const statusColors = {
  success: { bg: colors.greenLight, fg: colors.greenDark },
  pending: { bg: colors.amberLight, fg: colors.amber },
  failed: { bg: colors.redLight, fg: colors.red },
  idle: { bg: '#eceeec', fg: colors.slate },
}
